import React, { useMemo, useState } from "react";
import {
  CommentReplyTypes,
  UserFeedsType,
  UserFeeedCommentTypes,
} from "../../types";
import { UserCommentmenu, UserCommentContent, CommentReply } from "..";
import { useMutation, useQuery } from "@apollo/client";
import {
  CREATE_COMMENT_LIKE,
  DELETE_COMMENT_LIKE,
  GET_COMMENT_REPLY,
  GET_FEEDS_COMMENTS,
} from "../../apollo/operations";
import { useSelector } from "react-redux";
import { BsArrowReturnRight } from "react-icons/bs";
type UserCommentListProps = {
  refetch: () => void;
  userComments: UserFeeedCommentTypes | undefined;
  userFeed: UserFeedsType | undefined;
  isLoading: boolean;
};
const UserCommentList: React.FC<UserCommentListProps> = ({
  refetch,
  userComments,
  userFeed,
  isLoading,
}) => {
  const userComment = userComments?.comments;
  const [openOption, setOpenOption] = React.useState(false);
  const [deleteOption, setDeleteOption] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [replyComment, setReplyComment] = React.useState("");
  const [openInput, setOpenInput] = React.useState(false);
  const [deleteLikeLoading, setDeleteLikeLoading] = React.useState(false);
  const [createLikeLoading, setCreateLikeLoading] = React.useState(false);

  const { refetch: refetching } = useQuery(GET_FEEDS_COMMENTS, {
    variables: {
      where: {
        userFeed: {
          id: userFeed?.id,
        },
      },
    },
    onCompleted(data) {
      // console.log(data, "data comments");
    },
    onError: (err) => {
      console.log(err);
      const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMessage);
    },
  });
  const user = useSelector((state: any) => state.user.userDetails);
  const [editingCommentIndex, setEditingCommentIndex] = useState<number | null>(
    null
  );

  const [commentLike] = useMutation(CREATE_COMMENT_LIKE, {
    onCompleted: (data) => {
      if (refetch) {
        refetch();
      }
      refetching();
    },
    onError: (err) => {
      console.log(err);
      const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMessage);
    },
  });
  const [deleteCommentLike] = useMutation(DELETE_COMMENT_LIKE, {
    onCompleted: (data) => {
      console.log(data, "deleted data");
      if (refetch) {
        refetch();
      }
    },
    onError: (err) => {
      console.log(err);
      const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
      console.log(errorMessage);
    },
  });

  const commentLikeCreator = userComments?.commentLikes.find(
    (like) => like.user.id === user.id
  )?.id;
  const handleCommentLike = async (e: any) => {
    e.preventDefault();
    setCreateLikeLoading(true);
    if (!commentLikeCreator)
      await commentLike({
        variables: {
          data: {
            comment: {
              id: userComments?.id,
            },
            user: {
              id: user?.id,
            },
          },
        },
      }).then(() => {
        console.log(`liked by ${user.userDetails}`);
      });
  };

  const handleDeleteLike = async (e: any) => {
    e.preventDefault();
    setDeleteLikeLoading(true);
    if (commentLikeCreator) {
      await deleteCommentLike({
        variables: {
          where: {
            id: commentLikeCreator,
          },
        },
      });
    }
  };

  const handleOpenNotice = () => {
    setOpenOption(false);
    setDeleteOption(true);
  };
  const handleCloseNotice = () => {
    setDeleteOption(false);
  };
  const handleEdit = () => {
    setOpenOption(false);
    setOpenEdit(true);
  };
  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  useMemo(() => {
    if (!isLoading) {
      setCreateLikeLoading(false);
      setDeleteLikeLoading(false);
    }
  }, [isLoading]);

  // console.log(userComments?.id);
  const [getReply, setGetReply] = React.useState<
    CommentReplyTypes[] | undefined
  >([]);
  const [openReply, setOpenReply] = React.useState(false);
  const { refetch: refetchReply, loading: loadReply } = useQuery(
    GET_COMMENT_REPLY,
    {
      variables: {
        where: {
          comment: {
            id: userComments?.id,
          },
        },
      },
      notifyOnNetworkStatusChange: true,
      onCompleted: (data) => {
        // console.log(data.commentReplys, "comment reply");
        if (!loadReply) {
          setEditingCommentIndex(null);
        }
        setGetReply(data.commentReplys);
      },
      onError: (err) => {
        console.log(err);
        const errorMessage = err.graphQLErrors[0]?.extensions?.originalError;
        console.log(errorMessage);
      },
    }
  );
  const textAreaRef = React.useRef<HTMLTextAreaElement | null>(null);

  const replyButtonHandler = (user: string) => {
    const nameToInsert = `${user} `;

    setReplyComment(nameToInsert);

    setTimeout(() => {
      if (textAreaRef.current) {
        const newCursorPosition = nameToInsert.length;
        textAreaRef.current.setSelectionRange(
          newCursorPosition,
          newCursorPosition
        );
        textAreaRef.current.focus();
        if (window.innerWidth < 1298) {
          textAreaRef.current.style.marginLeft = "10px";
        } else {
          textAreaRef.current.style.marginLeft = "";
        }
      }
    }, 0);
  };

  const totalCommentLikes = userComments?.commentLikes.length || 0;

  const creator = userComments?.creator.username;
  const pImage =
    userComments?.creator && userComments.creator.ecobookProfile?.profileImage;
  return (
    <div className="flex flex-col w-full">
      <div
        className="grid w-full lg:mt-2 pt-2 lg:px-4 lg:pb-0"
        key={userComments?.id && userComments?.createdAt}
      >
        <div className="w-full flex flex-col lg:px-10 lg:py-7 rounded lg:shadow-[1px_-1px_8px_0px_rgba(0,0,0,0.1)] lg:gap-3 gap-1">
          <UserCommentmenu
            refetch={refetch}
            userFeed={userFeed}
            comments={userComments}
            openOption={openOption}
            deleteOption={deleteOption}
            setDeleteOption={setDeleteOption}
            setOpenOption={setOpenOption}
            pImage={pImage}
            handleEdit={handleEdit}
            handleOpenNotice={handleOpenNotice}
            handleCloseEdit={handleCloseNotice}
          />
          <UserCommentContent
            userComment={userComment}
            userFeed={userComments}
            refetch={refetch}
            openEdit={openEdit}
            handleCloseEdit={handleCloseEdit}
            pImage={pImage}
          />
        </div>
        <div className="flex justify-between text-darkGreen text-[10px] lg:text-base mt-2 font-Rubik font-light">
          <div className="flex font-medium lg:pl-5 relative">
            {createLikeLoading || deleteLikeLoading ? (
              <p>
                {deleteLikeLoading ? (
                  totalCommentLikes > 1 ? (
                    <span className="absolute left-0 lg:left-3">{`${
                      totalCommentLikes - 1
                    }`}</span>
                  ) : (
                    totalCommentLikes === 1 && " "
                  )
                ) : (
                  createLikeLoading && (
                    <span className="absolute left-0 lg:left-3">{`${
                      totalCommentLikes + 1
                    }`}</span>
                  )
                )}
                <span
                  className={
                    deleteLikeLoading
                      ? "text-darkGreen mr-4 lg:ml-1 ml-2"
                      : "text-red-400 mr-4 lg:ml-1 ml-2"
                  }
                >
                  Like
                </span>
              </p>
            ) : (
              <>
                {userComments?.commentLikes &&
                userComments.commentLikes.length > 0 ? (
                  <div className="absolute left-0 lg:left-3">
                    {userComments.commentLikes.length}
                  </div>
                ) : null}
                <div className="cursor-pointer mr-4 ml-2 lg:ml-1 flex">
                  <button
                    onClick={
                      commentLikeCreator && user.id
                        ? handleDeleteLike
                        : handleCommentLike
                    }
                    className={
                      commentLikeCreator && user.id
                        ? "text-red-400"
                        : "text-darkGreen"
                    }
                  >
                    Like
                  </button>
                </div>
              </>
            )}
            <button
              onClick={() => {
                setOpenInput(true);
                setOpenReply(true);
                replyButtonHandler(`@${creator}`!);
              }}
            >
              Reply
            </button>
          </div>
        </div>
      </div>
      {getReply && getReply.length > 0 && !openReply && (
        <div
          className="flex gap-1 text-TransGrey lg:pl-20 text-[9px] lg:text-[12px] mt-2 items-center font-Rubik font-light cursor-pointer"
          onClick={() => setOpenReply(true)}
        >
          <BsArrowReturnRight />

          {`View ${getReply?.length} ${
            getReply.length === 1 ? "reply" : "replies"
          }`}
        </div>
      )}
      {openReply && (
        <CommentReply
          id={userComments?.id}
          replyComment={replyComment}
          setReplyComment={setReplyComment}
          openInput={openInput}
          setOpenInput={setOpenInput}
          getReply={getReply}
          refetch={refetchReply}
          loading={loadReply}
          textArea={textAreaRef}
          replyButtonHandler={replyButtonHandler}
          setEditingCommentIndex={setEditingCommentIndex}
          editingCommentIndex={editingCommentIndex}
        />
      )}
    </div>
  );
};

export default UserCommentList;
